/**
 * GemVault transfer coordination — worker mode.
 * Transfers run on the Hetzner worker; this module only triggers UI refresh.
 * The API creates jobs with status "pending"; the worker picks them up and
 * updates progress in MongoDB. Frontend polls /api/transfers for status.
 */

// ═══════════════════════════════════════════════
// PUBLIC API (same surface for Dashboard.jsx)
// ═══════════════════════════════════════════════

/** Queue is a no-op: worker picks up pending jobs. Just refresh so polling shows progress. */
export function startTransfers(jobIds, onProgress) {
  if (onProgress) onProgress();
}

/** No in-browser transfers to abort; cancel is handled by API (Dashboard calls /transfer/:id/cancel). */
export function cancelTransfer(_jobId) {}

/** No in-browser transfers to abort; cancel-all is handled by API. */
export function cancelAllTransfers() {}

export function getActiveCount() {
  return 0;
}

export function resumePendingTransfers(pendingIds, onProgress) {
  startTransfers(pendingIds, onProgress);
}
